import { Link } from "react-router-dom";
import { CalendarDays, MapPin, Building2 } from "lucide-react";

const STATUS_STYLES = {
  REGISTRATION_OPEN: "bg-secondary/15 text-secondary",
  UPCOMING: "bg-accent/20 text-primary",
  ONGOING: "bg-primary text-primary-foreground",
  RESCHEDULED: "bg-orange-100 text-orange-700",
  POSTPONED: "bg-orange-100 text-orange-700",
  CANCELLED: "bg-destructive/15 text-destructive",
  COMPLETED: "bg-muted text-muted-foreground",
};

const trDate = (iso) =>
  iso ? new Date(iso).toLocaleDateString("tr-TR", { day: "numeric", month: "short" }) : "";

export const countdownLabel = (fair) => {
  const days = fair.days_until;
  if (fair.status === "CANCELLED") return "İptal edildi";
  if (fair.status === "COMPLETED") return "Tamamlandı";
  if (days === null || days === undefined) return "";
  if (days === 0) return "Bugün başladı";
  if (days < 0) return "Devam ediyor";
  return `${days} gün kaldı`;
};

export const FairCard = ({ fair, compact = false }) => (
  <Link
    to={`/fuarlar/${fair.slug}`}
    data-testid={`fair-card-${fair.slug}`}
    className="app-tap group flex flex-col overflow-hidden rounded-xl border border-border bg-card transition-shadow hover:shadow-lg"
  >
    <div className="relative aspect-[16/9] overflow-hidden bg-muted">
      <img src={fair.cover_image} alt={fair.name} loading="lazy"
        className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" />
      <div className="absolute left-2 top-2 flex flex-wrap gap-1">
        <span data-testid={`fair-status-${fair.slug}`}
          className={`rounded-full px-2 py-1 text-[10px] font-bold ${
            STATUS_STYLES[fair.status] || "bg-card text-primary"}`}>
          {fair.status_label}
        </span>
        {fair.is_new && (
          <span className="rounded-full bg-accent px-2 py-1 text-[10px] font-bold text-accent-foreground">
            YENİ
          </span>
        )}
      </div>
    </div>
    <div className="flex flex-1 flex-col gap-2 p-4">
      <p className="font-display text-base font-extrabold leading-snug text-primary line-clamp-2">
        {fair.name}
      </p>
      <p className="inline-flex items-center gap-1.5 text-sm text-muted-foreground">
        <CalendarDays className="h-4 w-4 shrink-0 text-secondary" />
        {trDate(fair.start_date)} – {trDate(fair.end_date)}
      </p>
      <p className="inline-flex items-center gap-1.5 text-sm text-muted-foreground">
        <MapPin className="h-4 w-4 shrink-0 text-secondary" />
        {fair.province || "Türkiye"}
        {fair.venue_name ? ` · ${fair.venue_name}` : ""}
      </p>
      {!compact && fair.organizer_name && (
        <p className="inline-flex items-center gap-1.5 text-xs text-muted-foreground line-clamp-1">
          <Building2 className="h-3.5 w-3.5 shrink-0" /> {fair.organizer_name}
        </p>
      )}
      <div className="mt-auto flex flex-wrap items-center gap-1.5 pt-2">
        {(fair.category_labels || []).slice(0, 3).map((c) => (
          <span key={c} className="rounded-full border border-border px-2 py-0.5 text-[11px] font-semibold text-primary">
            {c}
          </span>
        ))}
        <span className="ml-auto text-xs font-bold text-secondary">{countdownLabel(fair)}</span>
      </div>
    </div>
  </Link>
);
